import { Injectable } from "@angular/core";
import { NetworkService } from "../../shared/network.service";

@Injectable()
export class RolesService {
  constructor(private networkService: NetworkService) {}

  getRolesList() {
    return this.networkService.get("api/role", null, null, "bearer");
  }
  getApprovedData(query) {
    return this.networkService.get("api/vendor?" + query, null, null, "bearer");
  }
  updatePost(body) {
    return this.networkService.put(
      "api/drivers/assignVendor",
      body,
      null,
      "bearer"
    );
  }
  getAdminsList(query) {
    return this.networkService.get("api/admin?" + query, null, null, "bearer");
  }
  deleteRoleAPI(roleId: any) {
    return this.networkService.delete(
      "api/role/" + roleId,
      null,
      null,
      "bearer"
    );
  }
  deleteAdminAPI(adminId: any) {
    return this.networkService.delete(
      "api/admin/" + adminId,
      null,
      null,
      "bearer"
    );
  }
  createRole(request: any) {
    return this.networkService.post("api/role", request, null, "bearer");
  }
  updateAdmin(request: any) {
    return this.networkService.put("api/admin", request, null, "bearer");
  }
  verifyUser(request: any) {
    return this.networkService.post("api/admin", request, null, "bearer");
  }
  getAuditLogsListApi(roleId: any) {
    return this.networkService.get(
      "api/role/auditLog/" + roleId,
      null,
      null,
      "bearer"
    );
  }
}
